//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        isShow: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            userInfo: JSON.parse(localStorage.getItem('userInfo')),
            currentTabIndex: 0,
            currentIndex: -1,
            names: '',
            message: '',
            digit: '',
            pageParams: {
                pageNum: 0,
                pageSize: 99
            },
            yjList: [],
            travelsLists: [
            ]
        }
    },
    created() {
        this.getList();
    },
    methods: {
        jumpPage() {
            this.$router.push({
                name: 'travelsNotes',
            })
        },
        onClick() {
        },


        getYjLsit(username) {
            return new Promise((resolve, reject) => {
                this.$http
                    .get(`/api/wtcp-traveltips/noteSelf/selfList?username=${this.userInfo ? this.userInfo.user.username : ''}&access_token=${this.userInfo ? this.userInfo.access_token : ''}`, {
                        headers: {
                            'Access-Control-Allow-Origin': '*',
                            'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
                        }
                    })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },


        getList() {
            const self = this;
            let result = self.getYjLsit();
            result.then(v => {
                v.data.forEach(i => {
                    i.select = false
                });
                self.travelsLists = v.data
            });

        },
        // 选择游记
        handleSelectTravel(item, index) {
            if (!item.select) {
                this.yjList.push(item)
            } else {
                this.yjList = this.yjList.filter(i => i.title !== item.title)
            }
            item.select = !item.select
        },
        // 确认选择的游记
        handleConfirm() {
            // if (this.currentTabIndex === 1 && this.currentIndex < 0) {
            //   this.$dialog.alert({
            //     title: '提示',
            //     message: '请选择一项游记！'
            //   })
            // }
            if (!this.names) {
                this.$dialog.alert({
                    title: '提示',
                    message: '请输入段落名称！'
                })
            } else if (!this.message) {
                this.$dialog.alert({
                    title: '提示',
                    message: '请输入段落简介！'
                })
            } else if (!this.digit) {
                this.$dialog.alert({
                    title: '提示',
                    message: '请输入段落权重！'
                })
            } else {
                if (this.currentTabIndex === 1) {
                    this.$emit('confirm', this.yjList, { name: this.names, des: this.message, sortNum: this.digit })

                    this.names = ''
                    this.message = ''
                    this.digit = ''
                    this.currentTabIndex = 0
                    this.yjList = []
                    this.travelsLists.forEach(i => {
                        i.select = false
                    });
                } else {
                    this.currentTabIndex = 1
                }
            }


            // this.names = ''
            // this.message = ''
            // this.digit = ''
        },
        // 取消添加段落
        handleCancel() {
            this.$emit('cancel')
            this.yjList = []
            this.travelsLists.forEach(i => {
                i.select = false
            });
        }
    }
}
